export const statusQueryKeys = {
  id: 'id',
  name: 'name',
  nameEn: 'name_en',
  parentName: 'parent_name',
  modelId: 'model_id',
  createdAt: 'created_at',
  description: 'descr',
};
